"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MethodLogger = void 0;
const defaultParams = {
    type: "debug",
    inputs: true,
    outputs: true
};
function MethodLogger(params) {
    const options = {
        type: (params === null || params === void 0 ? void 0 : params.type) || defaultParams.type,
        inputs: (params === null || params === void 0 ? void 0 : params.inputs) === undefined ? defaultParams.inputs : params.inputs,
        outputs: (params === null || params === void 0 ? void 0 : params.outputs) === undefined ? defaultParams.outputs : params.outputs
    };
    return function (target, propertyKey, descriptor) {
        const original = descriptor.value;
        descriptor.value = function (...args) {
            if (options.inputs) {
                console[options.type]("Logged inputs:", args);
            }
            const result = original.apply(this, args);
            if (options.outputs) {
                console[options.type]("Logged outputs", result);
            }
            return result;
        };
    };
}
exports.MethodLogger = MethodLogger;
